import type { CompleteBookingFragment } from '@drycut/graphql';

type Props = {
  booking?: CompleteBookingFragment | null;
};

export function BookingServices({ booking }: Props): null | React.ReactElement {
  const services = booking?.services;

  if (!services || services.length === 0) return null;

  return (
    <div className="absolute -right-8 top-3 flex flex-col items-end gap-1 p-1">
      {services.map((service) => (
        <span
          key={service.id}
          className="rounded-full border-white border-2 bg-primary-500/80 px-2 py-0.5 text-xs font-medium text-primary-100 leading-tight"
        >
          {service.name}
        </span>
      ))}
    </div>
  );
}
